import $axios from "../../api";

const state = {
  loading: '',
  lockerList: [],
  totalLocker: 0,
  totalAvailableLocker: 0,
  totalOccupiedLocker: 0,
  searchResults: [],
  errors: []
}

const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LOCKER_LIST(state, payload) {
    state.lockerList = payload;
  },
  SET_TOTAL_LOCKER(state, payload) {
    state.totalLocker = payload;
  },
  SET_TOTAL_AVAILABLE_LOCKER(state, payload) {
    state.totalAvailableLocker = payload;
  },
  SET_TOTAL_OCCUPIED_LOCKER(state, payload) {
    state.totalOccupiedLocker = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SEARCH_RESULTS(state, payload) {
    state.searchResults = payload;
  }
}

const actions = {
  getLockerList({ commit, dispatch }) {
    commit('SET_LOADING', 'list');
    return new Promise((resolve, reject) => {
      $axios.get('/hr/locker-management/list')
        .then(response => {
          commit('SET_LOCKER_LIST', response.data.data.lockers);
          commit('SET_TOTAL_LOCKER', response.data.data.total_locker);
          commit('SET_TOTAL_AVAILABLE_LOCKER', response.data.data.available_locker);
          commit('SET_TOTAL_OCCUPIED_LOCKER', response.data.data.occupied_locker);

          resolve();
        })
        .catch(error => {
          dispatch('Main/globalSweetAlert', error.response, { root: true })
          reject(error);
        })
        .finally(() => {
          commit('SET_LOADING', '');
        });
    });
  },
  updateLocker({ commit, dispatch }, { locker_number, assigned_to }) {
    commit('SET_LOADING', 'update');
    return new Promise((resolve, reject) => {
      $axios.put(`/hr/locker-management/update/${locker_number}`, { assigned_to })
        .then(response => {
          resolve();
        })
        .catch(error => {
          dispatch('Main/globalSweetAlert', error.response, { root: true })
          reject(error);
        })
        .finally(() => {
          commit('SET_LOADING', '');
        });
    });
  },
  searchLocker({ commit, dispatch }, { query }) {
    commit('SET_LOADING', 'search');

    return new Promise((resolve, reject) => {
      $axios.get(`/hr/locker-management/search?query=${query}`)
        .then(response => {
          commit('SET_SEARCH_RESULTS', response.data.data);
          resolve();
        })
        .catch(error => {
          dispatch('Main/globalSweetAlert', error.response, { root: true })
          reject(error);
        })
        .finally(() => {
          commit('SET_LOADING', '');
        });
    });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}